export default function translate(text, placeholders = {}) {
  for (const placeholder in placeholders) {
    text = text.replace(new RegExp(`\\{\\{\\s*${placeholder}\\s*\\}\\}`, "g"), placeholders[placeholder]?.trim())
  }

  return text
}